import React from "react";
import { FaLine } from "react-icons/fa";

// LINE公式アカウントID（@を含む）
const lineId = "@camarago";

// メッセージを受け取ってURLを作る関数
const createLineUrl = (message) =>
  `https://line.me/R/oaMessage/${lineId}/?${encodeURIComponent(message)}`;

// ボタン用のメッセージ一覧
const options = [
  { label: "現地調査の依頼をしたい", message: "現地調査をしてほしい" },
  { label: "カメラの設置について相談したい", message: "設置に関する相談" },
  { label: "商品に関する相談をしたい", message: "商品に関する相談" },
  { label: "その他", message: " " },
];

const ContactLine = () => {
  return (
    <div className="bg-white rounded-xs w-11/12 md:w-1/2 m-auto">
      <div className="py-5 pl-3 w-11/12">
        <h2 className="text-xl font-bold">LINEでのお問い合わせはこちら</h2>
        <p className="text-black pt-2">
          どのようなことが疑問ですか？気軽に相談を始めるならLINEからのお問い合わせがおすすめです。
        </p>
        <small className="block underline py-2 leading-relaxed">
          クリックしたボタンに応じて自動でメッセージが作成されます。変更せずにそのまま送信してください。
        </small>
        <small className="block">
          スマートフォン以外から閲覧されている場合、LINEでのお問合せが機能しない場合がございます。
        </small>
      </div>
      <div className="space-y-10 w-11/12 md:w-4/5 m-auto py-10">
        {options.map((option, index) => (
          <a
            key={index}
            href={createLineUrl(option.message)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#06C755] text-white py-3 px-5 rounded-md shadow-md hover:opacity-90 transition"
          >
            <FaLine className="text-xl" />
            {option.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContactLine;
